import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appHorizontalScroll]',
  standalone: true,
})
export class HorizontalScrollDirective {
  // Enable horizontal scrolling with the mouse wheel

  constructor(private element: ElementRef) {}
  // Listen to the wheel event and apply horizontal scroll
  @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent): void {
    if (event.deltaY === 0) return;

    event.preventDefault();
    this.element.nativeElement.scrollLeft += event.deltaY;
  }
}
